import axios from '@/libs/axios'

export const fetchProductCatalog = () =>
  axios.get('/product-catalog')

export const submitProductPurchase = (data) =>
  axios.post('/product-purchases', data)

export const fetchMyProductPurchases = () =>
  axios.get('/product-purchases')

